function handleBasicScrollObserver(entries, observer) {
	console.log(entries);
	entries.forEach((entry) => {
		if (entry.isIntersecting && entry.target.classList.contains("u-watch")) {
			entry.target.classList.add("u-watch--active");
		} else {
			entry.target.classList.remove("u-watch--active");
		}
	});
}

function handleOutScrollObserver(entries) {
	entries.forEach((entry) => {
		if (!entry.isIntersecting && entry.boundingClientRect.top <= 0) {
			entry.target.classList.add("u-watch--active-out");
		} else {
			entry.target.classList.remove("u-watch--active-out");
		}
	});
}

function handleLazyLoadImages(entries, observer) {
	entries.forEach((entry) => {
		if (
			entry.isIntersecting &&
			entry.target.getAttribute("loading") === "lazy"
		) {
			// Might as well store the img element in a variable since we need it for so much
			let imgEle = entry.target;
			let imageUrl = imgEle.getAttribute("src");

			if (imageUrl) {
				imgEle.src = imageUrl;

				// Check if the image has already loaded, if so add our animation class to it
				if (imgEle.complete) {
					imgEle.classList.add("lazy-image--loaded");
				} else {
					// If it hasn't finished loaded an a load even listener that will add the class once it's done
					imgEle.onload = () => {
						imgEle.classList.add("lazy-image--loaded");
					};
				}

				observer.unobserve(entry.target);
			}
		}
	});
}

export default function scrollRevealInit() {
	const basicScrollObserver = new IntersectionObserver(
		handleBasicScrollObserver,
		{
			root: document.querySelector(".wp-site-blocks"),
			rootMargin: "-25% 0% -25% 0%",
			threshold: 0,
		}
	);

	const lazyImageObserver = new IntersectionObserver(handleLazyLoadImages, {
		threshold: 0.1,
	});

	const watchers = document.querySelectorAll(`.u-watch`);

	if (watchers) {
		[].forEach.call(watchers, (watcher) => {
			basicScrollObserver.observe(watcher);
		});
	}

	// const outWatchers = document.querySelectorAll(`.u-watch--out`);

	// if (outWatchers) {
	//   [].forEach.call(outWatchers, (watcher) => {
	//     outScrollObserver.observe(watcher);
	//   });
	// }

	const imgWatchers = document.querySelectorAll(".lazy-image");
	if (imgWatchers) {
		[].forEach.call(imgWatchers, (watcher) => {
			lazyImageObserver.observe(watcher);
		});
	}
}
